import { render } from "./SubcategoriesList.vue?vue&type=template&id=4a8c608c&ts=true"
import script from "./SubcategoriesList.vue?vue&type=script&lang=ts"
export * from "./SubcategoriesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__